import { Directive, input } from '@angular/core';

// Slides its element in when it appears: from the right when the direction is positive (going forward), from the left
// when it is negative (going back). Nothing moves at 0.
@Directive({
  selector: '[pxcSlideIn]',
  host: {
    '[class.animate-in]': 'pxcSlideIn() !== 0',
    '[class.fade-in]': 'pxcSlideIn() !== 0',
    '[class.duration-300]': 'pxcSlideIn() !== 0',
    '[class.slide-in-from-right-8]': 'pxcSlideIn() > 0',
    '[class.slide-in-from-left-8]': 'pxcSlideIn() < 0',
  },
})
export class SlideInDirective {
  readonly pxcSlideIn = input.required<number>();
}
